// extracted by mini-css-extract-plugin
export default {"bigNumbers":"Clock_bigNumbers__9UMkh"};